import { FC, HTMLAttributes } from "react";
import {
  ITypographyProps,
  Typography,
  TypographyVariant,
} from "../../core/Typography/Typography";
import { Image } from "../../core/Image/Image";
import GemIcon from "../../assets/gem_1x.webp";
import GemIcon2x from "../../assets/gem_2x.webp";
import GemIcon3x from "../../assets/gem_3x.webp";
import { useStyles } from "./GemNumber.style";
import clsx from "classnames";

interface IGemNumberProps extends ITypographyProps {
  amount: number;
  gemSize?: number;
}

export const GemNumber: FC<
  IGemNumberProps & HTMLAttributes<HTMLParagraphElement>
> = (props) => {
  const {
    amount,
    gemSize = 20,
    variant = TypographyVariant.BodyB5Bold,
    ...otherProps
  } = props;
  const classes = useStyles();

  return (
    <Typography
      variant={variant}
      className={clsx(classes.root, otherProps.className)}
      {...otherProps}
    >
      <Image
        src={GemIcon}
        src2x={GemIcon2x}
        src3x={GemIcon3x}
        width={gemSize}
        height={gemSize}
      />
      {amount}
    </Typography>
  );
};
